import { CalendarState, ExtraPageResource } from "burde";
import { getCalendarMaxNumberOfExtraPages } from "page/calendar/helper";
import { useState, useEffect } from "react";
import {
    CalendarType,
    ExtraPagePageSize,
    MonthDividerNumberOfPages,
} from "svg/constants";
import * as api from "util/api";

const useExtraPages = (calendar: CalendarState) => {
    const [extraPages, setExtraPages] = useState<ExtraPageResource[]>();
    const [monthDividers, setMonthDividers] = useState<ExtraPageResource[]>();
    const [maxNumberOfPages, setMaxNumberOfPages] = useState(Number);
    const [numberOfPagesLeft, setNumberOfPagesLeft] = useState(Number);
    const [loading, setLoading] = useState(false);

    const getExtraPages = async () => {
        setLoading(true);
        const { culture, calendarSize, calendarType } = calendar;

        const { success, data } = await api.json.get("api/ui/GetExtraPages", {
            culture,
            calendarSize,
            calendarType,
        });

        if (success) {
            setExtraPages(data.extraContentResources);
        }

        setLoading(false);
    };

    const getMonthDividers = async () => {
        setLoading(true);
        const { culture, calendarSize } = calendar;

        const { success, data } = await api.json.get(
            "api/ui/GetMonthDividers",
            {
                culture,
                calendarSize,
            },
        );

        if (success) {
            setMonthDividers(data.extraContentResources);
        }

        setLoading(false);
    };

    useEffect(() => {
        const calendarNumberOfExtraPages = getCalendarMaxNumberOfExtraPages(
            calendar.calendarType,
            calendar.calendarSize,
        );

        let maxNumberOfPages =
            calendar.monthDivider === null
                ? calendarNumberOfExtraPages
                : calendarNumberOfExtraPages - MonthDividerNumberOfPages;

        if (
            calendar.calendarType.toLowerCase() ===
            CalendarType.Notebook.toLowerCase()
        ) {
            maxNumberOfPages = calendar.customNumberOfEndPages;
        }

        const currentNumberOfPages =
            calendar.extraPages.length * ExtraPagePageSize;

        setMaxNumberOfPages(maxNumberOfPages);
        setNumberOfPagesLeft(maxNumberOfPages - currentNumberOfPages);
    }, [calendar.monthDivider, calendar.extraPages, calendar.calendarType]);

    useEffect(() => {
        getExtraPages();
        getMonthDividers();
    }, []);

    return {
        extraPages,
        monthDividers,
        loading,
        maxNumberOfPages,
        numberOfPagesLeft,
    };
};

export { useExtraPages };
